import { FetchesData } from "kinnect-mixins";
import {
	KAutocomplete,
	KForm,
	KLink,
	KTextField
} from "kinnect-general";
import { PricingHelpField } from "kinnect-models";
import {
	VBtn,
	VCard,
	VCol,
	VIcon,
	VRow,
	VContainer,
	VTooltip
} from "vuetify/lib";
import { objectToFormData } from "object-to-formdata";

export default KForm.extend( {
	name: "KPricingHelpForm",

	mixins: [ FetchesData ],

	props: {
		pricingHelp: Object,

		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "pricingHelpList" } ]
		}
	},

	data: () => ( {
		originalFileUrl: null,
		formFields: {
			name: null,
			url: null,
			file: null,
			fields: []
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.pricingHelp );
		},

		formUrl() {
			return this.editing
				? `pricing/${this.pricingHelp.id}?_method=PUT`
				: "pricing";
		},

		formData() {
			return objectToFormData( this.formFields, { indices: true } );
		},

		genFileField() {
			if ( this.formFields.file ) {
				return <div class="mb-3">
					{this.originalFileUrl
						? <KLink
							href={this.originalFileUrl}
							icon="attach_file"
							target="_blank"
						>
							Pricing Help File
						</KLink>
						: <span><VIcon>attach_file</VIcon> Pricing Help File</span>
					}

					<VBtn
						class="ml-2"
						onClick={() => {
							this.formFields.file = null;
							this.originalFileUrl = null;
						}}
						small
						outlined
					>
						<VIcon left>delete</VIcon> Remove File
					</VBtn>
				</div>;
			}

			return <KTextField
				accept=".gif,.jpg,.jpeg,.png,.doc,.docx,.pdf,.txt,.rtf,.xls,.xlsx,.csv"
				label="Pricing Help File"
				nativeOnChange={this.onFileChange}
				prependIcon="attach_file"
				type="file"
			></KTextField>;
		},

		genFieldCreator() {
			return <VCard outlined>
				<VContainer>
					{this.formFields.fields.map( ( fields, i ) =>
						<VRow key={`field-${i}`}>
							<VCol class="py-0" cols={12} sm={6} md={5}>
								<KAutocomplete
									itemText="name"
									itemValue="id"
									items={this.pricingHelpFields}
									label="Field Label*"
									loading={this.$wait.is( "get pricing help fields" )}
									required
									vModel={fields.id}
									validationName="field type"
									validationRules="required"
								></KAutocomplete>
							</VCol>

							<VCol class="py-0" cols={12} sm={6} md={7}>
								<KTextField
									label="Field Value*"
									required
									vModel={fields.value}
									validationName="field value"
									validationRules="required"
								>
									<VTooltip
										bottom
										scopedSlots={{
											activator: ( { on } ) =>
												<VBtn
													icon
													on={on}
													onClick={() => this.removeField( i )}
												>
													<VIcon>delete</VIcon>
												</VBtn>
										}}
										slot="append-outer"
									><span>Remove this field</span></VTooltip>
								</KTextField>
							</VCol>
						</VRow>
					)}

					<VRow>
						<VCol>
							<VBtn
								onClick={this.addField}
								outlined
							>
								<VIcon left>add_circle</VIcon> Add New Field
							</VBtn>
						</VCol>
					</VRow>
				</VContainer>

			</VCard>;
		}
	},

	watch: {
		pricingHelp: {
			handler( pricingHelp ) {
				if ( pricingHelp ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( pricingHelp.hasOwnProperty( key )
							&& key !== "fields"
						) {
							this.formFields[key] = pricingHelp[key];
						}
					} );

					this.originalFileUrl = pricingHelp.fileUrl;

					this.formFields.fields = pricingHelp.fields.map( field => ( {
						id: field.id,
						value: field.value
					} ) );
				}
			},
			immediate: true
		}
	},

	methods: {
		onFileChange( e ) {
			const files = e.target.files || e.dataTransfer.files;

			if ( files.length ) {
				this.formFields.file = files[0];
			} else {
				this.formFields.file = null;
			}
		},

		addField() {
			this.formFields.fields.push( {
				id: null,
				value: null
			} );
		},

		removeField( index ) {
			this.formFields.fields.splice( index, 1 );
		},

		async fetchPricingHelpFields() {
			this.pricingHelpFields = await PricingHelpField.get();
		},

		async fetch() {
			await this.fetchPricingHelpFields();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formData,
				method: "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				class="ml-blank-icon"
				label="Vendor Name*"
				required
				vModel={this.formFields.name}
				validationName="name"
				validationRules="required"
			></KTextField>

			<KTextField
				label="Website URL"
				prependIcon="language"
				vModel={this.formFields.url}
				validationName="website URL"
				validationRules={{ url: { require_protocol: true } }}
			></KTextField>

			{this.genFileField}

			{this.genFieldCreator}
		</KForm>;
	}
} );
